export default __webpack_public_path__ + "static/media/5 (1).2d808f5b.jpg";